import HierarchyNodeForm from './HierarchyNodeForm';
import TopicWorkspace from './TopicWorkspace';
import { LEVELS_BY_KEY } from './courseLevels';

// Switches on what's selected in the outline tree: nothing selected -> the
// Course's own header form (Course isn't a tree node itself); a hierarchy
// node (module/chapter/unit/lesson) -> the generic name/description editor;
// a topic -> its dedicated workspace (name/description + linked exercises +
// content blocks). Topics now live in their own cache (a Topic can be
// hosted by any of 5 levels, not just lesson - see useCourseWorkspace.js),
// so they're looked up and saved through the topic-specific actions
// (selected.hostLevelKey identifies which of the 5 possible parent fields
// this particular topic uses).
export default function DetailPanel({ course, saveCourse, selected, actions }) {
   if(!selected) {
      return (
         <div className='course-detail-panel'>
            <HierarchyNodeForm node={course} onSave={saveCourse} title={LEVELS_BY_KEY.course.label} levelKey='course' />
         </div>
      );
   }

   if(selected.levelKey === 'topic') {
      const topic = actions.getTopicNode(selected.hostLevelKey, selected.parentId, selected.id);
      if(!topic) {
         return <div className='course-detail-panel course-detail-empty'>Елемент не знайдено (можливо, його щойно видалили).</div>;
      }
      return (
         <div className='course-detail-panel'>
            <TopicWorkspace topic={topic} courseId={course.id}
               onSave={(changes) => actions.updateTopic(selected.hostLevelKey, selected.parentId, topic, changes)} />
         </div>
      );
   }

   const level = LEVELS_BY_KEY[selected.levelKey];
   const node = actions.getNode(selected.levelKey, selected.parentId, selected.id);

   if(!node) {
      return <div className='course-detail-panel course-detail-empty'>Елемент не знайдено (можливо, його щойно видалили).</div>;
   }

   return (
      <div className='course-detail-panel'>
         <HierarchyNodeForm node={node} title={level.label} levelKey={selected.levelKey}
            onSave={(changes) => actions.updateNode(selected.levelKey, selected.parentId, node, changes)} />
      </div>
   );
}
